export const name = {
    'en': 'Google Sheets',
    'zh-tw': 'Google 試算表'
};

export const googleJSON = {
    'en': 'get data from Google Sheet URL [url]',
    'zh-tw': '取得 Google 試算表共用連結 [url]'
};

export const readFromJSON = {
    'en': 'Google data',
    'zh-tw': '讀取的 Google 資料'
};

export const jsonFormNum = {
    'en': 'length of Google [variable] ',
    'zh-tw': 'Google [variable]資料筆數'
};

export const googlecolumnTEXT = {
    'en': 'value of the column name [column] of item #[n] of Google [variable]',
    'zh-tw': 'Google [variable] 第 [n] 筆欄位名稱[column]的值 '
};

/*
export const writeGoogleCalc = {
    'en': 'Google API URL: [url] write [column1] to Col1,[column2] to Col2, [column3] to Col3,[column4] to Col4,[column5] to Col5,[column6] to Col6,[column7] to Col7,[column8] to Col8',
    'zh-tw': 'Google api網址：[url] 寫入 欄位1：[column1] 欄位2：[column2] 欄位3：[column3] 欄位4：[column4] 欄位5：[column5] 欄位6：[column6] 欄位7：[column7] 欄位8：[column8]'
};
*/

export const writeGoogleForm = {
    'en': 'Google Form ID [googleID] Col1 ID [column1_name] Col1 value [column1_value], Col2 ID [column2_name] Col2 value [column2_value], Col3 ID [column3_name] Col3 value [column3_value] ',
    'zh-tw': 'Google 表單ID [googleID] 欄位1 ID [column1_name] 欄位1值 [column1_value]，欄位2 ID [column2_name] 欄位2值 [column2_value]，欄位3 ID [column3_name] 欄位3值 [column3_value]'
};

/*
export const onJSONReceived = {
    'en': 'When JSON data is recieved',
    'zh-tw': '當收到 JSON 資料時'
};
*/

export const readFromJSONErr = {
    'en': 'Error: Google data does not exist',
    'zh-tw': '錯誤：Google 資料不存在'
};

export const readGoogleSheetURL = {
    'en': 'obtain the deploy URL [url] of Google Sheet',
    'zh-tw': '取得 Google 試算表部署網址[url]'
};

export const writeGoogleSheetCol = {
    'en': 'insert value [value] into the column name [column] of Google Sheet',
    'zh-tw': '寫入試算表欄位名稱[column]值[value]'
};

export const sendGoogleSheet = {
    'en': 'submit data to Google Sheet',
    'zh-tw': '送出 Google 試算表的資料'
};

export const readGoogleSheetURL_1 = {
    'en': 'obtain the share URL [url] of Google Sheet',
    'zh-tw': '*取得 Google 試算表分享網址[url]'
};

export const readGoogleSheetTAG_1 = {
    'en': 'obtain the worksheet name [tag] of Google Sheet',
    'zh-tw': '*取得 Google 試算表的工作表名稱[tag]'
};

export const writeGoogleSheetCol_1 = {
    //'en': 'insert value [value] into column of Google Sheet',
    //'zh-tw': '*寫入試算表值[value]'
    'en': 'Write Spreadsheet Values [value1][value2][value3]',
    'zh-tw': '*寫入欄位的值[value1][value2][value3]'
};

export const readGoogleSheetCol_1 ={
    'en': 'cell col [COL] row[ROW] value of Google Sheet',
    'zh-tw': '*儲存格欄[COL]列[ROW]的值'
}

export const readGoogleSheet_json ={
    'en': 'read Google Sheet cell from col [COL_b] row[ROW_b] to col[COL_e] row[ROW_e] value to data ',
    'zh-tw': '*讀取從[COL_b]欄[ROW_b]列 到[COL_e]欄[ROW_e]列的值到資料'
}

export const sendGoogleSheet_1 = {
    'en': 'submit data to Google Sheet',
    'zh-tw': '*送出資料到Google試算表'
};

export const sendGoogleSheet_2 = {
    'en': 'col[COL_b] row[ROW_b] submit data to Google Sheet',
    'zh-tw': '*寫入Google試算表,起始 欄[COL_b] 列[ROW_b]'
};

export const queryTheNumber = {
    'en': 'Query data [data] column [field] data value [data2] in which number',
    'zh-tw': '查詢資料[data]中欄位[field]的資料值[data2]在第幾筆'
};

export const readGoogleFormID = {
    'en': 'obtain the ID[ID] of Google Form',
    'zh-tw': '取得 Google 表單 ID[ID]'
};

export const writeGoogleFormCol = {
    'en': 'insert the value [value] into the column ID [column] of Google Form',
    'zh-tw': '寫入 Google 表單欄位 ID[column]值[value]'
};

export const sendGoogleForm = {
    'en': 'submit data to Google Form',
    'zh-tw': '送出 Google 表單的資料'
};

export const readGooglesheet_err = {
    'en': 'Need google spreadsheet share url and sheet name',
    'zh-tw': '需要google試算表分享網址和工作表名稱'
}

export const data = {
    'en': 'data',
    'zh-tw': '資料'
};

export const Column_name = {
    'en': 'column name',
    'zh-tw': '欄位名稱'
};

export const number = {
    'en': 'number',
    'zh-tw': '數值'
};

export const value = {
    'en': 'text',
    'zh-tw': '文字'
};

export const value2 = {
    'en': 'value',
    'zh-tw': '值'
};

export const useTextSearchGetData = {
    'en': 'in JSON data [data] get all the values of the column [column2], when the column [column] of contains value [value] ',
    'zh-tw': '查詢資料[data]的欄位[column]若包含[value]的值，取得欄位[column2]的值'
};

export const useTextSearchGetData2 = {
    'en': 'Retrieve all data in the data [data] where the field [column] contains the value [value]',
    'zh-tw': '查詢資料[data]中欄位[column]包含特定值[value]的所有資料'
};

export const useNumberCompareGetData = {
    'en': 'in JSON data [data] get all the values of the column [column2], when the column [column] [symbol] [number]',
    'zh-tw': '查詢資料[data]的欄位[column]數值是否[symbol][number]，取得欄位[column2]的值'
};

export const selectData = {
    'en': 'Query data [data] Filter field [field] whether [symbol] value [value]',
    'zh-tw': '查詢資料[data]篩選欄位[field]是否[symbol]數值[value]'
};

export const clearworksheet = {
    'en': '*Clear worksheet data',
    'zh-tw': '*清除工作表內容'
};
